import React, {useEffect, useState} from 'react'
import axios from 'axios'
import LoadingOverlay from 'react-loading-overlay'
import {ChangePasswordForm} from '../../components/ChangePasswordForm/ChangePasswordForm'
import './PerfilVendedor.css'

function PerfilVendedor() {
  const API_URL = process.env.REACT_APP_API_URL
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [message, setMessage] = useState(null)

  useEffect(() => {
    axios.get(`${API_URL}/perfil-vendedor`).then(({data}) => setProfile(data.data)).catch((error) => setMessage({type: 'danger', text: error.response?.data?.message || 'No fue posible cargar tu perfil.'})).finally(() => setLoading(false))
  }, [API_URL])

  return <LoadingOverlay active={loading} spinner text='Cargando perfil...'><div className='perfil-vendedor'>
    <header><h1>Mi Perfil</h1><p>Consulta tus datos registrados.</p></header>
    {message && <div className={`alert alert-${message.type}`} role='status'>{message.text}</div>}
    <section><h2>Información general</h2><div className='perfil-vendedor-grid'>
      {[['Clave', profile?.clave], ['Nombre', profile?.nombre], ['Correo electrónico', profile?.email], ['Teléfono', profile?.telefono]].map(([label, value]) => <div className='perfil-vendedor-field' key={label}><span>{label}</span><strong>{value || 'No disponible'}</strong></div>)}
    </div></section>
    <section><h2>Contraseña y seguridad</h2><ChangePasswordForm endpoint='perfil-vendedor-password' /></section>
  </div></LoadingOverlay>
}

export {PerfilVendedor}
